import React from 'react'

type RowExpandedPropertyProps = {
	label: string
	value: string | null | React.ReactNode
	className?: string
}

const RowExpandedProperty = ({
	label,
	className = undefined,
	value,
}: RowExpandedPropertyProps) => {
	return (
		<div className={className}>
			<p className="font-rubik text-sm text-slate-500 font-bold mb-1 dark:text-slate-400">
				{label}
			</p>

			{React.isValidElement(value) ? (
				value
			) : (
				<p className="whitespace-normal font-rubik text-slate-800 font-bold mb-3 text-ellipsis overflow-hidden dark:text-white">
					{value}
				</p>
			)}
		</div>
	)
}

export default RowExpandedProperty
